"use client";

import { cn } from "@/lib/utils";
import stepsAmico from "@public/stepsAmico.png";
import Image from "next/image";
import { FaqItems } from "@/constants";
import { Accordion, FlexCenter } from "../ui";
import AppContainer from "../appContainer";
import { useState } from "react";

const FaqSection = () => {
  const [openAccordionId, setOpenAccordionId] = useState<string | null>(
    FaqItems[0]?.id || null,
  );
  return (
    <section className={cn("mb-37 w-full")}>
      <AppContainer className={cn("h-full max-w-[70rem]")}>
        <FlexCenter
          className={cn(
            "mx-auto max-w-[700px] flex-col gap-8 lg:max-w-[900px] lg:flex-row lg:gap-40 xl:max-w-full",
          )}
        >
          <div
            className={cn(
              "flex w-full flex-col items-center gap-6 lg:basis-[300px]",
            )}
          >
            <span
              className={cn(
                "text-primary-main xl:text-heading-3 text-xl font-bold",
              )}
            >
              سوالات متداول
            </span>
            <figure className="max-w-[50%] sm:max-w-[30%] lg:w-3xs lg:max-w-full">
              <Image
                alt="سوالات پرتکرار سامانه استعلام نوین"
                className={cn("size-full rounded-[14px] object-cover")}
                src={stepsAmico}
                title="سوالات پرتکرار سامانه استعلام نوین"
              />
            </figure>
          </div>
          <div className={cn("flex w-full flex-col gap-2")}>
            {FaqItems.map((faq) => (
              <Accordion
                key={faq.id}
                title={faq.title}
                open={faq.id === openAccordionId}
                onOpenChange={(isOpen) => {
                  setOpenAccordionId(isOpen ? faq.id : null);
                }}
              >
                {Array.isArray(faq.content) ? (
                  <ul className="p-4 pt-2">
                    {faq.content.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                ) : (
                  <p className="p-4 pt-2">{faq.content}</p>
                )}
              </Accordion>
            ))}
          </div>
        </FlexCenter>
      </AppContainer>
    </section>
  );
};

export default FaqSection;
